import { TTicketDetails } from '@daymade/api-contracts';
import { GameType } from '@daymade/common-lib/dbEnums';
import EntryStack from 'components/ticket/EntryStack';
import { DaymadeDrawTypePlanCode } from 'constants/Draw';
import { getTicketBackground } from 'utils/ticket/getTicketBackground';

interface IEntriesSection {
  tickets: TTicketDetails[];
}

export const EntriesSection = ({ tickets }: IEntriesSection) => {
  return (
    <div className="w-full px-[1em]">
      <div className="border-solid rounded-xl border-[2px] border-[#E1E1E1] py-6">
        <div className="px-5 font-black text-[17px] mb-3">My Entries</div>
        {tickets.map((ticket, index) =>
          ticket.entries.map(
            (entry, ind) =>
              entry.type === GameType.LOTTERY && (
                <EntryStack
                  key={ind}
                  entry={entry}
                  style={{
                    marginTop: ind === 0 ? 0 : '-13%',
                  }}
                  stackCount={1}
                  backgroundImage={getTicketBackground(
                    ticket.drawTypePlan.code as DaymadeDrawTypePlanCode
                  )}
                />
              )
          )
        )}
      </div>
    </div>
  );
};
